import { render } from "./ResumeButton.vue?vue&type=template&id=764fd27f&scoped=true"
import script from "./ResumeButton.vue?vue&type=script&lang=js"
export * from "./ResumeButton.vue?vue&type=script&lang=js"

import "./ResumeButton.vue?vue&type=style&index=0&id=764fd27f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764fd27f"]])

export default __exports__